import { IAction } from '../../models/action/core';
import { Log } from 'ng2-logger';
import { Dispatch } from 'react';

const _logger = Log.create('Action Logger');

const ActionLogger = (store: any) => {
    return (next: Dispatch<any>) => {
        return (action: any) => {
            return next(action);
        };
    };
};

export default ActionLogger;
